import { render, staticRenderFns } from "./create-or-edit-bankInfo.vue?vue&type=template&id=83df0028&scoped=true&"
import script from "./create-or-edit-bankInfo.vue?vue&type=script&lang=js&"
export * from "./create-or-edit-bankInfo.vue?vue&type=script&lang=js&"
import style0 from "./create-or-edit-bankInfo.vue?vue&type=style&index=0&id=83df0028&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83df0028",
  null
  
)

export default component.exports